import type { FaireProductEntity } from "../../entity_types/product";

export const p_qx8tvkxcmc: FaireProductEntity = {
  token: "p_qx8tvkxcmc",
  type: "product",
  name: "Turkey Tail - Fruiting Body - 1:1 Water Extracted - Organic",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/52f8557d681263a3ad4947e40b5d47b0503817dcccf097172272478d94a01962.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e49a1ffd61347e12422e92ea6ae7ba321d613031d2449c33bc491613a63f56a9.png",
    "https://cdn.faire.com/fastly/eb4478c108d7288c992e69825a03ec3f31cfffe8a66225c052ab134655e18def.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "We love Turkey Tail for its ability to boost our immune system, support gut health, and regulate blood sugar.*\n\nOur Turkey Tail is organically cultivated in its favorite substrates (no starch, grains, or fillers) and 1:1 water extracted for bioavailability.\n\nFun Fact: Polysaccharide Peptides (PSP) from turkey tail have prebiotic abilities and helps the gut regulate its balance of bacteria.\n\nBeta Glucans | 450mg per serving\n\nServings | 2 grams, 31 servings per package\n\n• Always grown outdoors in hoop houses, not in labs.\n\n• Triple tested for safety & Mushroom compounds\n\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease or health condition.",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:45.848Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
